var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"积分设置","name":"first"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"积分明细","name":"second"}})],1),_vm._v(" "),(_vm.activeName == 'first')?_c('Setting'):_vm._e(),_vm._v(" "),(_vm.activeName == 'second')?_c('Log'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d9be58","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/points/index.vue
// module id = null
// module chunks = 